import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown } from 'lucide-react';
import { Button } from './ui/Button';
import { WaveDivider } from './WaveDivider';
export function HeroSection() {
  const scrollToForm = () => {
    const element = document.getElementById('intake-form');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-coastal-gradient text-white pt-20 pb-32" data-id="element-55">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-56">
        <div className="absolute top-20 left-10 w-64 h-64 bg-white/10 rounded-full blur-3xl animate-float" data-id="element-57" />
        <div className="absolute bottom-40 right-10 w-96 h-96 bg-secondary-light/20 rounded-full blur-3xl animate-float" style={{
        animationDelay: '2s'
      }} data-id="element-58" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-60">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-sm font-medium mb-6 border border-white/30" data-id="element-61">
            Professional Tax Preparation
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 tracking-tight leading-tight" data-id="element-62">
            You Deserve a <br className="hidden md:block" data-id="element-63" />
            <span className="text-accent-light" data-id="element-64">Tax Concierge.</span>
          </h1>

          <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-65">
            Stress-free tax preparation for professionals in Southern California
            — prepared by a CPA or EA and guided by a USC Marshall graduate.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-66">
            <Button variant="white" size="lg" onClick={scrollToForm} className="w-full sm:w-auto text-primary-dark font-semibold shadow-lg shadow-primary-dark/20" data-id="element-67">
              Start My Tax Prep
            </Button>
            <Button variant="outline" size="lg" onClick={() => document.getElementById('value-section')?.scrollIntoView({
            behavior: 'smooth'
          })} className="w-full sm:w-auto border-white text-white hover:bg-white/10" data-id="element-68">
              Learn More
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-24 left-1/2 transform -translate-x-1/2" animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} data-id="element-69">
        <ArrowDown className="w-6 h-6 text-white/70" data-id="element-70" />
      </motion.div>

      <div className="absolute bottom-0 left-0 right-0" data-id="element-71">
        <WaveDivider color="#FFFFFF" data-id="element-72" />
      </div>
    </section>;
}